<template>
  <div class="h-auto w-full mr-3">
    <div class="bg-white mx-3 rounded-b-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold w-full">List of Departments</p>
      </div>

      <div class="flex justify-between items-center pr-3">
        <div class="flex">
          <div
            class="flex rounded-md"
            style="
              justify-content: center;
              flex-direction: row;
              align-items: center;
            "
          ></div>
          <div class="flex justify-between items-center">
            <el-pagination
              background
              @size-change="handleSizeChange"
              :page-sizes="pageSizes"
              :page-index="pageIndex"
              :page-size="pageSize"
              layout="sizes"
              :total="currentTableData.length"
            >
            </el-pagination>
            <input
              v-model="searchInput"
              type="search"
              placeholder="Start typing to search..."
              class="p-2 bg-gray-200 w-52 m-2 py-1 rounded-md"
            />
          </div>
        </div>
        <div class="flex flex-wrap justify-end w-full gap-3 pr-3">
          <button
            @click="showCreateDepartment = true"
            class="bg-primary text-white rounded-full py-1 px-1 items-center text-sm flex gap-1 align-middle"
          >
            <svg
              id="Layer_1"
              height="20"
              viewBox="0 0 24 24"
              width="20"
              xmlns="http://www.w3.org/2000/svg"
              data-name="Layer 1"
              fill="#fff"
            >
              <path
                d="m12 0a12 12 0 1 0 12 12 12.013 12.013 0 0 0 -12-12zm4 13h-3v3a1 1 0 0 1 -2 0v-3h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2z"
              />
            </svg>
            Create
          </button>
        </div>
      </div>

      <div class="px-2 pb-2 relative">
        <transition name="fade">
          <div v-if="loading" class="inset-0 absolute z-50 bg-white w-full">
            <loader class="center-h-v" />
          </div>
        </transition>

        <div>
          <ve-table
            v-if="searchInput"
            :columns="columns"
            :table-data="filteredTableData"
            sort-order="asc"
            :expand-option="expandOption"
            :row-style-option="rowStyleOption"
            :row-key-field-name="'DepartmentId'"
          />

          <ve-table
            :columns="columns"
            :tableData="currentTableData"
            v-if="!searchInput.length"
            :expand-option="expandOption"
            :row-style-option="rowStyleOption"
            :row-key-field-name="'DepartmentId'"
          >
          </ve-table>

          <p
            v-if="searchInput.length && filteredTableData.length === 0"
            class="text-center py-3"
          >
            No results
          </p>

          <p
            v-if="tableData.length == 0 && !loading && !get_error"
            class="p-1 text-center text-sm w-full bg-gray-100"
          >
            No Departments found
          </p>
          <!-- Pagination -->
          <div class="table-pagination text-center mt-2">
            <!-- <ve-pagination :total="totalCount" :page-index="pageIndex" :page-size="pageSize"
              @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" :show-jumper="false" /> -->
            <el-pagination
              background
              layout="prev, pager, next"
              :total="totalCount"
              :page-size="pageSize"
              @current-change="handleCurrentChange"
            >
              <!-- :current-page.sync="currentPage4" -->
            </el-pagination>
          </div>
          <!-- Pagination -->
        </div>
        <transition name="fade">
          <div
            v-if="get_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ get_error }}
          </div>
        </transition>
      </div>
    </div>
    <!-- create -->
    <CreateDepartment
      @close="handleClose"
      :showCreateDepartment="showCreateDepartment"
      @closeOnSuccess="handleCloseOnSuccess"
    >
    </CreateDepartment>

    <AddSubDepartment
      @close="showCreateSubDepartment = false"
      :showCreateSubDepartment="showCreateSubDepartment"
      :selectedRow="selectedRow"
      @closeOnSuccess="handleCloseOnAddDept"
      :reload="reload"
    ></AddSubDepartment>

    <EditDepartment
      @close="handleClose"
      :showEditDepartment="showEditDepartment"
      :departmentToEdit="departmentToEdit"
      @closeOnSuccess="handleCloseOnAddDept"
      :reload="reload"
    ></EditDepartment>

    <EditSubDepartment
      @close="showEditSubDepartment = false"
      :showEditSubDepartment="showEditSubDepartment"
      :subDepartmentToEdit="subDepartmentToEdit"
      @closeOnSuccess="handleCloseOnAddDept"
      :reload="reload"
    >
    </EditSubDepartment>

    <action-warning
      :message="message"
      :set-is-confirmed="setIsConfirmed"
      :show-warning="showWarning"
      @close="showWarning = false"
      :title="title"
    ></action-warning>
    <BulkUpload
      v-if="showBulkUpload"
      :close="close"
      :showBulkUpload="showBulkUpload"
      :showBulkUploadCallback="showBulkUploadCallback"
      :title="title"
      dataType="Companies"
      :url="url"
      :dateColumns="[]"
      :columns="resultColumns"
    ></BulkUpload>
    <BulkUploadAssets
      :show-asset-bulk-upload="showAssetBulkUpload"
      v-if="showAssetBulkUpload"
      @close="showAssetBulkUpload = false"
      :reload="reload"
    ></BulkUploadAssets>
  </div>
</template>

<script>
import axios from "axios";
import Loader from "@/components/loader/loader.vue";
import { mapGetters } from "vuex";
//import { utils, writeFileXLSX } from "xlsx";
import ActionWarning from "../../../utils/actionWarning.vue";
import BulkUploadAssets from "@/components/employees/modals/bulkUploadAssets.vue";
import { importTemplateGenerator } from "@/utils/importTemplateGenerator";
import decryptData from "@/utils/decrypt";
// import { createPopper } from '@popperjs/core';

export default {
  name: "departmentsList",
  components: {
    Loader,

    BulkUpload: () => import("@/utils/bulkUploadsUtils.vue"),
    CreateDepartment: () =>
      import("@/components/CompanySetups/departments/create.vue"),
    AddSubDepartment: () =>
      import("@/components/CompanySetups/departments/addSubDepartment.vue"),
    EditDepartment: () =>
      import("@/components/CompanySetups/departments/editDepartments.vue"),
    EditSubDepartment: () =>
      import("@/components/CompanySetups/departments/editSubDepartments.vue"),
    ActionWarning,
    BulkUploadAssets,
  },
  data() {
    return {
      rowStyleOption: {
        clickHighlight: true,
      },
      url: "",
      title: "Department List",
      showBulkUpload: false,
      showAssetBulkUpload: false,
      showCreateDepartment: false,
      showCreateSubDepartment: false,
      showEditSubDepartment: false,
      showAddDepartment: false,
      subDepartmentToEdit: null,
      subDepartmentToDelete: null,
      loading: false,
      tableData2: [],
      get_error: null,
      filteredTabs: [],
      linemanagers: [],
      departments: [],
      selectedRow: null,
      departmentDetails: null,
      searchInput: "",
      message: null,
      pageIndex: 1,
      // page size
      pageSize: 10,
      pageSizes: [],

      employees: [],
      showWarning: false,
      departmentToDelete: null,
      departmentToEdit: {
        Id: "",
        Name: "",
      },

      showEditDepartment: false,
      create_success: "department created successfully",
      del_loca: "department deleted successfully",
      add_dept_success: "Departments have been added successfully",
      del_error: null,
      showLocCrSuccess: false,
      showAddDepartmentSuccess: false,
      showLocDelSuccess: null,
      saved_departments: null,

      currentPage: 1,
      perPage: 2,

      expandOption: {
        render: ({ row, column, rowIndex }, h) => {
          this.selectedRow = row;
          row, column, rowIndex, h;
          const { SubDepartments } = row;

          return (
            <div class="my-2">
              <div class="border-b-0.5 flex justify-between items-center pb-2">
                <p class="text-sm font-semibold w-full">
                  List of Sub Departments for {row.Name}
                </p>
                <div class="flex flex-wrap justify-end w-full gap-3">
                  <button
                    onClick={this.handleAddSubDepartment}
                    class="bg-primary text-white rounded-full px-3 py-1 text-sm"
                  >
                    Create Sub Department
                  </button>
                </div>
              </div>
              <ve-table
                columns={this.subDepartmentColumns}
                table-data={SubDepartments}
                sort-order="asc"
                row-key-field-name="SubDepartmentId"
              />
              {SubDepartments.length === 0 ? (
                <p class="p-1 text-center text-sm w-full bg-gray-100 text-center">
                  No Sub-departments found for {row.Name}
                </p>
              ) : null}
            </div>
          );
        },
      },

      columns: [
        {
          field: "",
          key: "department-expand",
          title: "",
          width: 10,

          align: "center",
          type: "expand",
        },
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,

          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },

        {
          field: "Name",
          key: "name",
          title: "Department Name",
          headerAlign: "left",
          align: "left",
          sampleValue: "Sales",
        },
        {
          field: "BranchName",
          key: "BranchName",
          title: "Branch Name",
          headerAlign: "left",
          align: "left",
          sampleValue: "HQ,",
        },
        {
          field: "LocationName",
          key: "LocationName",
          title: "Company",
          headerAlign: "left",
          align: "left",
          sampleValue: "Microsoft",
        },

        {
          field: "DepartmentManager",
          key: "DepartmentManager",
          title: "Department Manager",
          headerAlign: "left",
          align: "left",
          sampleValue: "Josephina Anyango",
          renderBodyCell: ({ row }) => {
            return decryptData(row.DepartmentManager, this.$decryptionKey);
          },
        },

        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0, 10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleEditButtonClick(row)}
                >
                  Edit
                </button>
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleAddDivision(row)}
                >
                  Add Division
                </button>
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleDeleteButtonClick(row)}
                >
                  Delete
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],
      subDepartmentColumns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          // width: 10,

          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },

        {
          field: "SubDepartmentName",
          key: "SubDepartmentName",
          title: "Sub Department Name",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "SubDepartmentManager",
          key: "SubDepartmentManager",
          title: "Manager",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => {
            return decryptData(row.SubDepartmentManager, this.$decryptionKey);
          },
        },

        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleEditSubButtonClick(row)}
                >
                  Edit
                </button>

                <button
                  class="text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleDeleteSubButtonClick(row)}
                >
                  Delete
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],
      tableData: [],
      subDepartmentsTableData: [],
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
    // table data
    paginationTableData() {
      const { pageIndex, pageSize } = this;
      //console.log(this.tableData)
      return this.tableData.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },
    // total count
    totalCount() {
      return this.tableData.length;
    },
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.tableData;
      } else {
        // Filter the tableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return this.tableData.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    // table data
    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;
      return this.tableData.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },
    // total count
  },
  created() {
    this.getDepartments();
    this.getEmployees();
    this.setPageSizes();
    this.filteredTabs = this.columns.filter(
      (column) => column.title !== "Action"
    );
  },

  methods: {
    // /{organization}/employee/all/v1/request
    getEmployees() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/employee/all/${this.$ApiVersion}/request`,
          options
        )
        .then((response) => {
          this.loading = false;
          //console.log(response.data)
          this.employees = response.data.Data;
        });
    },
    close() {
      this.showBulkUpload = false;
      this.$emit("close");
      this.showEditSubDepartment = false;
    },
    showBulkUploadCallback() {
      this.showBulkUpload = false;
    },
    showBulkUploadForm() {
      this.resultColumns = this.columns.filter((col) => col.title !== "Action");
      this.showBulkUpload = true;
    },
    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
    // page number change

    reload() {
      this.getDepartments();
      setTimeout(() => {
        this.showAssetBulkUpload = false;
      }, 3000);
    },
    setIsConfirmed() {
      this.showWarning = false;
      if (this.departmentToDelete) {
        this.deleteDepartment(this.departmentToDelete);
        return;
      }
      this.deleteSubDepartment(this.subDepartmentToDelete);
    },

    changePage(page) {
      this.currentPage = page;
    },
    // /{organization}/setup/department/{departmentId}/sub-departments/v1/edit
    handleEditSubButtonClick(department) {
      // Handle the button click for the edit button
      //console.log(this.selectedRow);
      console.log(department);
      this.getEmployees();
      this.subDepartmentToEdit = {
        SubDepartmentId: department.SubDepartmentId,
        SubDepartmentName: department.SubDepartmentName,
        SubDepartmentManagerId: department.SubDepartmentManagerId,
        DepartmentId: this.selectedRow.DepartmentId,

        ...department,
      };
      //console.log(this.subDepartmentToEdit)
      this.showEditSubDepartment = true;
    },

    handleDeleteSubButtonClick(department) {
      // Handle the button click for the delete button
      //console.log(department)
      this.title = `Delete ${department.SubDepartmentName} headed by ${department.SubDepartmentManager}`;
      this.message = `You are about to delete ${department.SubDepartmentName}!`;
      this.subDepartmentToDelete = department;

      this.showWarning = true;
    },

    handleAddDivision(row) {
      this.selectedRow = row;
      this.showCreateSubDepartment = true;
    },

    handleAddSubDepartment() {
      this.showCreateSubDepartment = true;
    },

    handleEditButtonClick(department) {
      // Handle the button click for the edit button
      this.getEmployees();
      const manager = this.employees.find(
        (employee) => employee.Id == department.DepartmentManagerId
      );
      //console.log(department.DepartmentManagerId, this.employees, department);
      this.departmentToEdit = {
        Id: department.DepartmentId,
        DepartmentId: department.DepartmentId,
        LocationId: department.LocationId,
        BranchId: department.BranchId,
        DepartmentManager: manager
          ? `${manager.EmployeeNo} - ${decryptData(
              manager.Fullname,
              this.$decryptionKey
            )}`
          : "",

        DepartmentManagerId: department.DepartmentManagerId,
        Name: department.Name,
        BranchName: department.BranchName,
        LocationName: department.LocationName,
        // ...department
      };
      //console.log(this.departmentToEdit)
      this.showEditDepartment = true;
    },
    handleDeleteButtonClick(department) {
      // Handle the button click for the delete button
      console.log(department);
      this.title = `Delete ${department.Name} of ${department.BranchName}, ${department.LocationName}`;
      this.message = `You are about to delete ${department.Name}!`;
      this.departmentToDelete = department;
      //console.log(this.departmentToDelete)
      this.showWarning = true;
    },
    handleClose() {
      this.showCreateDepartment = false;
      this.showEditDepartment = false;
    },
    handleCloseOnSuccess() {
      this.showCreateDepartment = false;
      this.showLocCrSuccess = true;
      setTimeout(() => {
        this.showLocCrSuccess = false;
      }, 3000);
      this.getDepartments();
    },

    handleDeleteOnSuccess() {
      setTimeout(() => {
        this.showLocDelSuccess = null;
      }, 3000);
      this.getDepartments();
    },

    AddDepartment(row) {
      this.selectedRow = row;
      this.showAddDepartment = true;
    },

    handleCloseOnAddDept() {
      this.showAddDepartment = false;
      this.showAddDepartmentSuccess = true;
      setTimeout(() => {
        this.showAddDepartmentSuccess = false;
      }, 3000);
    },

    // /{organization}/setup/department/v1/request
    getDepartments() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/department/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              //console.log(response.data.Data);
              this.tableData = response.data.Data;
              this.departments = response.data.Data;
              // this.subDepartmentsTableData = response.data.Data.
              // DB_DATA = response.data.Data
              // this.tableData.forEach((v, index) => {
              //   v.rowKey = `${index + ``}`;
              //   v.departments = [];
              // });
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    getLinemanagers() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/linemanagers/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;

            if (response.data.StatusCode == 200) {
              this.linemanagers = response.data.Data;
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },
    deleteDepartment(row) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json", // Ensure the Content-Type is set to JSON
        },
        data: {
          DepartmentId: row.DepartmentId, // Include the body in the options
        },
      };

      axios
        .delete(
          `${this.getOrganization}/setup/department/${row.DepartmentId}/v1/delete`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.showLocDelSuccess = response.data.StatusMessage;
              this.handleDeleteOnSuccess();
              // this.getDepartments()
            } else {
              this.del_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.del_error = error.message;
          }
        );
    },
    // /{organization}/setup/department/{departmentId}/sub-departments/{subDepartmentId}/v1/delete
    deleteSubDepartment(row) {
      const { DepartmentId } = this.selectedRow;
      const { SubDepartmentId } = row;

      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
        data: {
          DepartmentId,
          SubDepartmentId,
        },
      };
      axios
        .delete(
          `${this.getOrganization}/setup/department/subdepartment/v1/delete`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$notify.success({
                title: "Success",
                message: response.data.StatusMessage,
              });
              this.handleDeleteOnSuccess();
              // this.getDepartments()
            } else {
              this.$notify.error({
                title: "Failure",
                message: response.data.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;
            this.$notify.error({ title: "Failure", message: error.message });
          }
        );
    },
    exportTemplate() {
      importTemplateGenerator(
        this.filteredTabs,

        "Department List"
      );
    },
  },
};
</script>

<style>
.custom-menu {
  display: block;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10;
  min-width: 120px;
  padding: 0.5rem 0;
  margin: 0;
  list-style: none;
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.15);
}
</style>
